<template>
  <div class="upload-receipt-body" :class="[isEmpty ? 'is-empty' : '']">
    <div class="receipt-image-content" v-if="!isEmpty">
      <el-image
        class="receipt-image"
        v-for="(item, index) in listImageView"
        :key="item"
        :src="item"
        fit="contain"
        @click="onImagePreview(index)"
      >
      </el-image>
    </div>

    <div class="no-data-content" v-if="isEmpty">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="url in listImageView"
        :src="url || '/image/static/img/nopic.jpg'"
        :key="url"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: { shipmentExpenseCode: { type: String, default: '' } },
  data() {
    return {
      loading: false,
      listImage: [],
    }
  },
  computed: {
    listImageView() {
      return this.listImage.map((item) => item.fileUrl)
    },
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.shipmentExpenseCode) return
      this.loading = true
      const res = await this.$api
        .shipmentExpenseSelectReceiptApi({
          shipmentExpenseCode: this.shipmentExpenseCode,
        })
        .catch(() => null)
      this.loading = false
      this.listImage = res.body.data || []
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-receipt-body {
  height: 500px;
  overflow: auto;
  &.is-empty {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .receipt-image {
    width: 210px;
    height: 210px;
    margin: 20px;
    cursor: pointer;
  }
}
</style>
